﻿(() => {
  const bbbioForm = document.getElementById('bbbio-ngs-library-prep-form');
  const bbbioSamples = document.getElementById('bbbio-samples');
  const bbbioTemplate = document.getElementById('bbbio-sample-template');
  const bbbioStatus = document.getElementById('bbbio-status');
  const bbbioAuthorizationDate = document.getElementById('bbbio-authorization-date');
  const bbbioContactName = document.querySelector('[data-bbbio-library-contact-name]');
  const bbbioContactEmail = document.querySelector('[data-bbbio-library-contact-email]');
  const bbbioContactPhone = document.querySelector('[data-bbbio-library-contact-phone]');
  const bbbioContactBody = document.querySelector('[data-bbbio-library-contact-body]');

  if (!bbbioForm || !bbbioSamples || !bbbioTemplate || !bbbioStatus || !bbbioContactName || !bbbioContactEmail || !bbbioContactPhone || !bbbioContactBody) return;

  const bbbioServiceNames = {
    dna: 'DNA library',
    rna: 'RNA library',
    'small-rna': 'Small RNA library',
    amplicon: 'Amplicon library',
    microbiome: '16S or ITS library',
    metagenomic: 'Metagenomic library',
    'target-enrichment': 'Target-enrichment library',
    cfdna: 'Low-input or cfDNA library'
  };

  function bbbioShowStatus(message, type = 'success') {
    bbbioStatus.textContent = message;
    bbbioStatus.dataset.bbbioVisible = 'true';
    bbbioStatus.dataset.bbbioType = type;
  }
  function bbbioClearStatus() {
    bbbioStatus.textContent = '';
    bbbioStatus.dataset.bbbioVisible = 'false';
    delete bbbioStatus.dataset.bbbioType;
  }
  function bbbioSetConditional(group, visible) {
    group.hidden = !visible;
    group.querySelectorAll('input,select,textarea').forEach((control) => { control.disabled = !visible; });
  }
  function bbbioAssignDynamicLabels(card, sampleNumber) {
    card.querySelectorAll('[data-bbbio-field]').forEach((control) => {
      const key = control.dataset.bbbioField;
      const slug = key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
      const id = `bbbio-sample-${sampleNumber}-${slug}`;
      control.id = id;
      control.name = `sample_${sampleNumber}_${key}`;
      const wrapper = control.closest('.bbbio-form-field');
      if (wrapper) {
        const label = wrapper.querySelector('label:not(.bbbio-choice)');
        if (label) label.htmlFor = id;
      }
    });
    card.querySelectorAll('[data-bbbio-service]').forEach((control) => {
      const key = control.dataset.bbbioService;
      control.id = `bbbio-sample-${sampleNumber}-service-${key}`;
      control.name = `sample_${sampleNumber}_services`;
      control.value = key;
    });
  }
  function bbbioRenumberSamples() {
    const cards = Array.from(bbbioSamples.querySelectorAll('.bbbio-sample-card'));
    cards.forEach((card,index) => {
      const n=index+1;
      card.dataset.bbbioSampleIndex=String(n);
      const number=card.querySelector('.bbbio-sample-number');
      if (number) number.textContent=String(n);
      bbbioAssignDynamicLabels(card,n);
      const remove=card.querySelector('.bbbio-remove-sample');
      if (remove) remove.disabled=cards.length===1;
    });
  }
  function bbbioUpdateWarning(card) {
    const material=card.querySelector('.bbbio-sample-material').value;
    const rna=card.querySelector('[data-bbbio-service="rna"]').checked || card.querySelector('[data-bbbio-service="small-rna"]').checked;
    const cfdna=card.querySelector('[data-bbbio-service="cfdna"]').checked;
    const warning=card.querySelector('.bbbio-sample-warning');
    const incompatibleRna=['Purified genomic DNA','Purified cfDNA','Amplicon or PCR product','Microbial or metagenomic DNA'].includes(material);
    let message='';
    if (rna && incompatibleRna) message='An RNA library workflow requires RNA-containing input. Confirm the sample material or selected workflow.';
    else if (cfdna && material && !['Purified cfDNA','Plasma from blood collected in Streck tubes'].includes(material)) message='The low-input or cfDNA workflow is normally used with purified cfDNA or qualified plasma. Confirm compatibility with the technical team.';
    warning.textContent=message;
    warning.dataset.bbbioVisible=message ? 'true' : 'false';
  }
  function bbbioUpdateMaterialFields(card) {
    const material=card.querySelector('.bbbio-sample-material').value;
    const rna=card.querySelector('[data-bbbio-service="rna"]').checked || card.querySelector('[data-bbbio-service="small-rna"]').checked;
    const amplicon=card.querySelector('[data-bbbio-service="amplicon"]').checked || card.querySelector('[data-bbbio-service="microbiome"]').checked;
    const rules=[
      ['.bbbio-ffpe-fields', material==='FFPE DNA or RNA'],
      ['.bbbio-tissue-cell-fields', material==='Fresh or frozen tissue requiring extraction' || material==='Cells or cell pellet requiring extraction'],
      ['.bbbio-blood-fields', material==='Blood or bone marrow requiring extraction'],
      ['.bbbio-streck-fields', material==='Plasma from blood collected in Streck tubes'],
      ['.bbbio-rna-fields', rna],
      ['.bbbio-amplicon-fields', amplicon]
    ];
    rules.forEach(([selector,visible]) => {
      const group=card.querySelector(selector);
      if (group) bbbioSetConditional(group,visible);
    });
    bbbioUpdateWarning(card);
  }
  function bbbioAddSample(shouldFocus=true) {
    const fragment=bbbioTemplate.content.cloneNode(true);
    const card=fragment.querySelector('.bbbio-sample-card');
    card.querySelector('.bbbio-remove-sample').addEventListener('click',() => {
      if (bbbioSamples.querySelectorAll('.bbbio-sample-card').length>1) { card.remove(); bbbioRenumberSamples(); }
    });
    card.querySelector('.bbbio-sample-material').addEventListener('change',() => bbbioUpdateMaterialFields(card));
    card.querySelectorAll('[data-bbbio-service]').forEach((box) => box.addEventListener('change',() => bbbioUpdateMaterialFields(card)));
    bbbioSamples.appendChild(fragment);
    bbbioRenumberSamples();
    bbbioUpdateMaterialFields(card);
    if (shouldFocus) {
      const first=card.querySelector('[data-bbbio-field="sampleId"]');
      if (first) first.focus();
    }
  }
  function bbbioAddValue(target,key,value) {
    if (Object.prototype.hasOwnProperty.call(target,key)) target[key]=Array.isArray(target[key]) ? target[key].concat(value) : [target[key],value];
    else target[key]=value;
  }
  function bbbioCollectData() {
    const data={}; const samples=[];
    new FormData(bbbioForm).forEach((value,key) => {
      const isSystemField=key.startsWith('contact[') || ['form_type','utf8','h-captcha-response','g-recaptcha-response'].includes(key);
      if (!key.startsWith('sample_') && !key.startsWith('attest') && !isSystemField) bbbioAddValue(data,key,value);
    });
    bbbioSamples.querySelectorAll('.bbbio-sample-card').forEach((card) => {
      const sample={};
      card.querySelectorAll('[data-bbbio-field]:not(:disabled)').forEach((control) => { if (control.value!=='') sample[control.dataset.bbbioField]=control.value; });
      sample.services=Array.from(card.querySelectorAll('[data-bbbio-service]:checked')).map((control) => bbbioServiceNames[control.dataset.bbbioService]);
      samples.push(sample);
    });
    data.samples=samples;
    data.customerAttestations={
      accurate: document.getElementById('bbbio-attest-accurate').checked,
      noDirectIdentifiers: document.getElementById('bbbio-attest-identifiers').checked,
      hazardsDisclosed: document.getElementById('bbbio-attest-hazards').checked
    };
    data.generatedAt=new Date().toISOString();
    return data;
  }
  function bbbioValidateSelections() {
    if (!bbbioForm.querySelector('input[name="requestedServices"]:checked')) return 'Select at least one library-preparation service.';
    const missing=Array.from(bbbioSamples.querySelectorAll('.bbbio-sample-card')).some((card) => !card.querySelector('[data-bbbio-service]:checked'));
    return missing ? 'Select at least one library workflow for every sample.' : '';
  }

  document.getElementById('bbbio-add-sample').addEventListener('click',() => bbbioAddSample(true));
  document.getElementById('bbbio-print-form').addEventListener('click',() => window.print());
  bbbioForm.addEventListener('submit',(event) => {
    bbbioClearStatus();
    if (!bbbioForm.checkValidity()) { event.preventDefault(); bbbioForm.reportValidity(); bbbioShowStatus('Complete all required fields before submitting the request.','error'); return; }
    const selectionError=bbbioValidateSelections();
    if (selectionError) { event.preventDefault(); bbbioShowStatus(selectionError,'error'); return; }
    bbbioContactName.value=bbbioForm.elements.contactName.value;
    bbbioContactEmail.value=bbbioForm.elements.email.value;
    bbbioContactPhone.value=bbbioForm.elements.phone.value;
    bbbioContactBody.value=`NGS LIBRARY PREPARATION ORDER\n\n${JSON.stringify(bbbioCollectData(),null,2)}`;
    bbbioShowStatus('Submitting your request securely…');
  });
  document.getElementById('bbbio-download-json').addEventListener('click',() => {
    bbbioClearStatus();
    if (!bbbioForm.checkValidity()) { bbbioForm.reportValidity(); bbbioShowStatus('Complete all required fields before exporting the request.','error'); return; }
    const selectionError=bbbioValidateSelections();
    if (selectionError) { bbbioShowStatus(selectionError,'error'); return; }
    const blob=new Blob([JSON.stringify(bbbioCollectData(),null,2)],{type:'application/json'});
    const url=URL.createObjectURL(blob); const link=document.createElement('a');
    link.href=url; link.download='bnb-bio-ngs-library-preparation-order.json'; document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url);
    bbbioShowStatus('Request JSON created locally. No submission was transmitted.');
  });
  bbbioForm.addEventListener('reset',() => setTimeout(() => {
    bbbioSamples.innerHTML=''; bbbioAddSample(false); bbbioClearStatus();
    if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate=new Date();
  },0));
  if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate=new Date();
  bbbioAddSample(false);
})();
